/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Group_Audio_DescriptionInputs */

const en_shortcut_keys_group_audio_description = /** @type {(inputs: Shortcut_Keys_Group_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio Description`)
};

const fr_shortcut_keys_group_audio_description = /** @type {(inputs: Shortcut_Keys_Group_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description audio`)
};

const de_shortcut_keys_group_audio_description = /** @type {(inputs: Shortcut_Keys_Group_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audiobeschreibung`)
};

const it_shortcut_keys_group_audio_description = /** @type {(inputs: Shortcut_Keys_Group_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizione audio`)
};

const ru_shortcut_keys_group_audio_description = /** @type {(inputs: Shortcut_Keys_Group_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аудиоописание`)
};

const es_shortcut_keys_group_audio_description = /** @type {(inputs: Shortcut_Keys_Group_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripción de audio`)
};

const zh_cn2_shortcut_keys_group_audio_description = /** @type {(inputs: Shortcut_Keys_Group_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音频描述`)
};

const ja_shortcut_keys_group_audio_description = /** @type {(inputs: Shortcut_Keys_Group_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオ説明`)
};

const hi_shortcut_keys_group_audio_description = /** @type {(inputs: Shortcut_Keys_Group_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो विवरण`)
};

const pt_pt2_shortcut_keys_group_audio_description = /** @type {(inputs: Shortcut_Keys_Group_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrição em áudio`)
};

/**
* | output |
* | --- |
* | "Audio Description" |
*
* @param {Shortcut_Keys_Group_Audio_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_group_audio_description = /** @type {((inputs?: Shortcut_Keys_Group_Audio_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Group_Audio_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_group_audio_description(inputs)
	if (locale === "de") return de_shortcut_keys_group_audio_description(inputs)
	if (locale === "it") return it_shortcut_keys_group_audio_description(inputs)
	if (locale === "ru") return ru_shortcut_keys_group_audio_description(inputs)
	if (locale === "es") return es_shortcut_keys_group_audio_description(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_group_audio_description(inputs)
	if (locale === "ja") return ja_shortcut_keys_group_audio_description(inputs)
	if (locale === "hi") return hi_shortcut_keys_group_audio_description(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_group_audio_description(inputs)
	return en_shortcut_keys_group_audio_description(inputs)
});